import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import * as _ from 'lodash';
import { PledgeProductRead } from '../../definition/interface/Pledge';
import { FormConfig } from '../../definition/types/subscription';
import FormGroupArray from '../../services/FormGroupArray';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  options: any = {};

  generateForm(entity: PledgeProductRead & { parameters: any }, options) {
    this.options = { ...options, ...entity };

    let avOptionInvestissementProgressifRepartition: UntypedFormGroup[] = [];

    const supportRepartitionIsin =
      entity?.parameters?.avOptionInvestissementProgressifRepartition;

    if (supportRepartitionIsin)
      _.forEach(supportRepartitionIsin, (scpi, i) =>
        avOptionInvestissementProgressifRepartition.push(
          this.formBuilder.group(this.createModel(scpi)),
        ),
      );

    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        productPackId: [entity?.parameters?.productPackId],
        avOptionInvestissementProgressifRepartition: this.formBuilder.array(
          avOptionInvestissementProgressifRepartition,
          Validators.nullValidator,
        ),
      }),
    };

    return this.formBuilder.group(formConfig, {});
  }
  generate(entity: any[], option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }
  get products() {
    return this.form.get('products') as UntypedFormArray;
  }
  get avOptionInvestissementProgressifRepartition() {
    return this.products
      .get(`${0}`)
      .get('parameters')
      .get('avOptionInvestissementProgressifRepartition') as UntypedFormArray;
  }

  private calculateRepartitionPercent(item): number | null {
    if (!item) {
      return 0;
    }
    return item?.repartition ? +item.repartition * 100 : 0;
  }
  public createModel(item) {
    let model = {
      id: [item ? item.id : null],
      isin: [item ? item.isin || item.supportIsin : null],
      index: [item ? item.index : null],
      omniprodId: [item ? item.omniProductId || item.omniprodId : null],
      name: [item ? item.name : null],
      repartition: [this.calculateRepartitionPercent(item)],
      monthlyRepartition: [item ? +item.monthlyRepartition : null],
      favorite: [item ? item.favorite : null],
      type: [item ? item.type : null],
      supportDescription: [this.options?.supportDescription || null],
      totalAvInitialPayment: [
        this.options && this.options?.parameters
          ? +this.options?.parameters?.avMonthlyPayment
          : null,
      ],
    };
    return model;
  }
  hasValidIsin(item) {
    return item.isin !== undefined && item.isin !== null;
  }
  convertToSupportRepartitionIsin(item) {
    return {
      isin: item.isin,
      name: item.name,
      repartition: item.repartition
        ? item.repartition / 100
        : 0,
      type: item.type,
    };
  }
  updateProductsWithRepartitionIsin(product, supportRepartitionIsin) {
    return {
      ...product,
      parameters: {
        ...product.parameters,
        avOptionInvestissementProgressifRepartition: supportRepartitionIsin,
      },
    };
  }

  extract() {
    const products = this.form.value?.products;
    const { avOptionInvestissementProgressifRepartition } =
      products?.[0]?.parameters || {};
    const validRepartition = _.filter(
      avOptionInvestissementProgressifRepartition,
      this.hasValidIsin,
    );
    /**
     * pick only isin
     */
    const supportRepartitionIsin =
      this.filterAndConvertToSupportRepartitionIsin(validRepartition);
    const productsIsin = _.map(products, o =>
      this.updateProductsWithRepartitionIsin(o, supportRepartitionIsin),
    );
    return productsIsin;
  }

  private filterAndConvertToSupportRepartitionIsin(validRepartition: any[]) {
    return _.map(validRepartition, this.convertToSupportRepartitionIsin);
  }
}
